<template>
  <v-card v-if="template" class="px-6 pt-2 pb-6" :height="`calc(100vh - 58px - ${!$store.state.auth.default_user ? '0px' : '24px'})`" style="overflow-y: auto">
    <v-overlay :value="value" z-index="1000" :opacity="0.3">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form v-model="valid">

      <select-project
        v-model="template.entity_id"
        class="mb-6"
      ></select-project>

      <v-text-field
        :disabled="value"
        v-model="template.name"
        label="Name"
        :rules="[v => !!v || 'Name is required']"
        required
      ></v-text-field>


      <v-text-field
        :disabled="value"
        v-model="template.explain"
        label="Explain"
        :rules="[v => !!v || 'Explain is required']"
        required
      />

      <v-combobox
        v-model="bcc"
        :disabled="value"
        :rules="bccRules"
        label="BCC"
        :search-input.sync="bccSearch"
        :error="!!bccSearch"
        :error-messages="!!bccSearch ? 'Press Enter to confirm input' : []"
        multiple
        clearable
      />

      <v-select
        v-if="hasNotificationAccess"
        v-model="notification_id"
        :items="notificationOptions"
        item-text="name"
        item-value="event_id"
        :disabled="value"
        clearable
        label="Notification Template"
      />

      <v-select
        v-model="mode"
        label="Mode"
        :items="MODE_OPTIONS"
      />

      <v-expansion-panels flat class="mail-template_settings">
        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <b class="py-1">Settings</b>
            <v-row
              v-if="!open"
              style="flex-direction: row-reverse"
              class="ma-0 pa-0"
            >

              <v-chip
                v-if="template.settings.deposit_error"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Deposit error
              </v-chip>

              <v-chip
                v-if="template.settings.retention_day"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Retention: {{ template.settings.retention_day }}
              </v-chip>

              <v-chip
                v-if="template.settings.tournament_finished || template.settings.tournament_started"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Tournament
              </v-chip>

              <v-chip
                v-if="template.settings.withdraw_complete || template.settings.notification_1h_after_withdraw"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Withdraw Notify
              </v-chip>

              <v-chip
                v-if="template.settings.bonus_notification_type || template.settings.benefit_id"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Benefit
              </v-chip>
              <v-chip
                v-if="template.settings.deposit_complete"
                outlined
                class="mr-3"
                small
                color="success"
              >
                Deposit Notify
              </v-chip>

            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-if="template" :class="{'ma-0': true }" justify="center">
              <v-text-field
                v-if=" !(template.settings.tournament_finished || template.settings.tournament_started)"
                :disabled="value"
                v-model="template.settings.retention_day"
                label="Retention Day"
                :rules="[v => isNumber(v) || 'Day should be a number']"
                :class="{'pb-0': true, 'pr-0': true, 'pt-0': !template.settings.retention_day, 'pl-0': true, 'mr-4': true, 'mt-0': true, 'col-2': true,}"
                :hide-details="!template.settings.retention_day"
              />

              <v-select
                v-if="template.settings.retention_day"
                :disabled="value"
                v-model="template.settings.type"
                :items="['casino', 'sport']"
                :rules="[v => !!v || 'Type is required']"
                label="Type"
                required
                class="pb-0 pr-0 mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day && !template.settings.tournament_started"
                v-model="template.settings.tournament_finished"
                label="Tournament Finished"
                class="mr-4 mt-0"
              />


              <v-checkbox
                v-if="!template.settings.retention_day && !template.settings.tournament_finished"
                v-model="template.settings.tournament_started"
                label="Tournament Started"
                class="mr-4 mt-0"
              />

              <v-text-field
                :disabled="value"
                v-if="!template.settings.retention_day && template.settings.tournament_finished"
                v-model="template.settings.place"
                label="Place"
                placeholder="Any"
                :rules="[v => isNumber(v) || 'Place should be a number']"
                class="pa-0 mr-4 mt-0 col-2"
              />

              <v-select
                v-if="!template.settings.retention_day && (template.settings.tournament_finished || template.settings.tournament_started)"
                :disabled="value"
                v-model="template.settings.tournament_id"
                :prefix="'#' + (template.settings.tournament_id || '')"
                :items="tournaments"
                item-value="template_id"
                item-text="title"
                label="Tournament"
                placeholder="Any"
                clearable
                class="pa-0 mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day  && !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.deposit_error"
                label="Deposit Error"
                class="mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.deposit_complete"
                label="Deposit complete"
                class="ml-4 mt-0"
              />

              <v-select
                v-if="template.settings.deposit_complete &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.nth_deposit"
                :items="[ {text: 'any', value: null} ,1, 2, 3, 4 ]"
                label="n-th Deposit"
                placeholder="Any"
                class="ml-4 mr-2 mt-0 pa-0 col-2"
              />

              <v-checkbox
                v-if="!template.settings.retention_day &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.birthday"
                label="Birthday"
                class="ml-4 mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.withdraw_complete"
                label="Withdraw complete"
                class="ml-4 mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.fast_withdraw_complete"
                label="Fast withdraw complete"
                class="ml-4 mt-0"
              />

              <v-checkbox
                v-if="!template.settings.retention_day &&  !(template.settings.tournament_finished || template.settings.tournament_started)"
                v-model="template.settings.notification_1h_after_withdraw"
                label="Notification after Withdraw complete"
                class="ml-4 mt-0"
              />

              <v-checkbox
                v-model="template.settings.kyc_verification_success"
                label="KYC verification success"
                class="ml-4 mt-0"
                hide-details
              />

              <v-checkbox
                v-model="template.settings.kyc_verification_fail"
                label="KYC verification fail"
                class="ml-4 mt-0"
                hide-details
              />

              <v-checkbox
                v-model="template.settings.kyc_document_approved"
                label="KYC document approved"
                class="ml-4 mt-0"
                hide-details
              />

              <v-checkbox
                v-model="template.settings.kyc_document_rejected"
                label="KYC document rejected"
                class="ml-4 mt-0"
                hide-details
              />

              <v-checkbox
                v-model="template.settings.withdrawal_pending"
                label="Withdrawal requested"
                class="ml-4 mt-0"
                hide-details
              />
              <v-checkbox
                v-model="template.settings.withdrawal_cancel"
                label="Withdrawal canceled"
                class="ml-4 mt-0"
                hide-details
              />
              <v-checkbox
                v-model="template.settings.withdrawal_failed"
                label="Withdrawal failed"
                class="ml-4 mt-0"
                hide-details
              />
              <v-checkbox
                v-model="template.settings.fast_withdrawal_failed"
                label="Fast withdrawal failed"
                class="ml-4 mt-0"
                hide-details
              />
            </v-row>

            <v-row v-if="template && $store.state.auth.checkAccess({ key: 'bonus_tools', value: true }) && !template.settings.retention_day  && !(template.settings.tournament_finished || template.settings.tournament_started)">
              <v-select
                label="Bonus Type"
                :items="bonusTypes"
                v-model="template.settings.bonus_notification_type"
                class="col-3 ml-4 mt-0 pt-0"
                clearable
              />
              <v-select
                label="Benefit"
                :items="benefits"
                v-model="template.settings.benefit_id"
                class="col ml-4 mt-0 pt-0"
                clearable
              />
            </v-row>
            <v-row>
              <v-combobox
                v-model="template.settings.tag"
                :items="tagsList"
                clearable
                multiple
                small-chips
                hide-selected
                label="Tag"
                class="col ml-4 mt-0 pt-0"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Create a new one <kbd>tag</kbd>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-btn
        v-if="!template.new && $store.state.auth.checkAccess({key: 'mail_template_update', value: true})"
        :loading="value"
        :disabled="!valid"
        @click="save()"
        color="primary"
        class="mt-4"
      >Save Template
      </v-btn>

      <v-divider class="mt-4" />
      <v-tabs
        v-model="currentLanguage"
        color="primary accent-4"
      >
        <v-tab
          v-for="(language, index) in languageList"
          :key="language"
          :class="{'mr-2': index === languageList.length - 1}"
        >
          {{ language }}
          <v-icon
            v-if="index === currentLanguage"
            @click="deleteTranslation(template.translation[currentLanguage])"
            class="language__close"
            color="error"
            size="small">
            mdi-close-circle
          </v-icon>
        </v-tab>
        <v-autocomplete
          v-if="newLanguageList.length"
          class="flex-grow-0 font-weight-medium pt-0 my-1"
          height="42px"
          :items="newLanguageList"
          :key="currentLanguage"
          placeholder="New Language"
          hide-details
          @input="addNewTranslation($event)"
        />
      </v-tabs>
      <template v-if="template.translation.length">
        <v-text-field
          :disabled="value"
          v-model="template.translation[currentLanguage].subject"
          label="Subject"
          class="mt-5"
          :rules="[v => !!v || 'Subject is required']"
          required
        />
        <tinymce-vue
          class="mt-3"
          :id="'mail-template-editor-' + (template.template_id || Date.now())"
          :other_options="config"
          ref="editor"
          v-model="editorText"
        />
      </template>

      <v-card-actions class="pa-0">
        <template v-if="$store.state.auth.checkAccess({key: 'mail_template_update', value: true})">
          <v-btn
            v-if="template.new"
            :loading="value"
            :disabled="!valid"
            @click="save(true)"
            color="primary"
            class="mt-4"
          >Create Template
          </v-btn>
          <v-btn
            v-else
            :loading="value"
            :disabled="!valid"
            @click="saveTranslation()"
            color="primary"
            class="mt-4"
          >Save Translations
          </v-btn>
        </template>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style>

  .mail-template_settings {
    border: 1px solid rgba(0, 0, 0, 0.12)
  }

  .mail-template_settings .v-expansion-panel-content__wrap {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
  }
</style>

<style scoped>
  .trumbowyg-box, .trumbowyg-editor {
    min-height: 550px !important;
  }

  .v-card {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .language__close {
    position: absolute;
    right: 5px;
    top: 10px;
  }
</style>

<script>
  import { isNaN, toNumber, isEmpty, map } from 'lodash'

  import '@/assets/css/tinymce-vue.css'
  import TinymceVue from 'tinymce-vue'
  import { API } from '@/utils/api'
  import { nextTick } from 'vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  // import Trumbowyg from 'vue-trumbowyg'

  // import 'trumbowyg/dist/ui/trumbowyg.css'
  // import 'trumbowyg/dist/ui/trumbowyg.min.css'
  // import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
  // import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
  // import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
  // import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
  // import 'trumbowyg/dist/plugins/pasteembed/trumbowyg.pasteembed.js'

  const MODE_ALL = 'all'
  const MODE_OPTIONS = [
    { text: 'All Users', value: MODE_ALL },
    { text: 'VIP only', value: 'vip_only' },
    { text: 'Non-VIP only', value: 'non_vip_only' },
  ]

  export default {

    props: [
      'template',
      'value',
      'save',
      'tagsList',
      'hasNotificationAccess',
      'notificationOptions',
    ],
    emits: [ 'loadMailTemplates' ],
    components: {
      SelectProject,
      TinymceVue,
    },

    data () {
      return {
        currentLanguage: 0,
        isLoadingEditor: true,
        tournaments: [],
        tag: '',
        benefits: [],
        bonusTypes: [
          { text: 'Period', value: 'period' },
          { text: 'Promotional', value: 'promo' },
          { text: 'Cashback', value: 'cashback' },
          { text: 'Retention', value: 'retention' },
          { text: 'Achievement', value: 'achievement' },
          { text: 'Journey', value: 'journey' },
        ],
        config: {
          height: 500,
          inline: false,
          theme: 'modern',
          fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 34px 38px 42px 48px 54px 60px',
          plugins: [ 'code fullpage visualchars image link media table  hr nonbreaking anchor toc lists textcolor wordcount  imagetools   contextmenu colorpicker textpattern' ],
          toolbar1: 'formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
          menubar: false,
          image_advtab: true,
          content_css: [
            // '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
            // '//www.tinymce.com/css/codepen.min.css'
          ],
          setup: (editor) => {
            editor.on('init', (e) => {
              this.isLoadingEditor = false
            })
          }
        },
        valid: false,
        bccRules: [
          v => {
            return v.every(email => {
              const parts = email.split('@')
              if (parts.length !== 2 || !parts[0] || !parts[1]) {
                return false
              }

              const [ host, domain ] = parts[1].split('.')

              if (!host || !domain) {
                return false
              }

              return true
            }) || 'Must be a valid email'
          },
        ],
        bccSearch: '',
        MODE_OPTIONS,
      }
    },

    methods: {
      isNumber: (v) => !isNaN(toNumber(v)) || isEmpty(v),

      loadTournaments: function () {
        if (!this.template.entity_id) return
        this.$emit('input', true)

        this.tournaments = []

        return API.call('/mail/dictionary/tournament_list.json', {
          statuses: this.statuses
        }, null, this.template.entity_id).then(resp => {
          this.tournaments = resp.data || []
        }).finally(() => this.$emit('input', false))
      },
      async saveTranslation () {
        this.$emit('input', true)
        try {
          const updatedTemplate = await API.call('/mail/translation/update.json', { template_id: this.template.template_id, translation: this.template.translation }, null, this.template.entity_id)
          this.template.translation = updatedTemplate.data
          this.$emit('loadMailTemplates')
        } catch (e) {
          console.error(e)
        } finally {
          this.$emit('input', false)
        }
      },
      async deleteTranslation (translation) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this translation?')) {
          if (!translation.template_translation_id) {
            this.$delete(this.template.translation, this.currentLanguage)
          } else {
            this.$emit('input', true)
            API.call('/mail/translation/delete.json', {
              template_translation_id: translation.template_translation_id
            }, null, this.template.entity_id).then(resp => {
              this.$emit('loadMailTemplates')
              this.$emit('loadMailTemplate', this.template.template_id)
            }).catch(e => {
            }).finally(() => this.$emit('input', false))
          }
          this.currentLanguage = this.currentLanguage - 1
        }
      },

      loadBonusBenefits: function () {
        if (!this.template.entity_id) return

        this.$emit('input', true)

        this.benefits = []

        if (this.$store.state.auth.checkAccess({ key: 'bonus_tools', value: true })) {
          return API.call('/mail/dictionary/benefit_list.json', {
            types: this.template.settings.bonus_notification_type ? [ this.template.settings.bonus_notification_type ] : []
          }, null, this.template.entity_id).then(resp => {
            this.benefits = resp.data || []
          }).finally(() => this.$emit('input', false))
        }
      },
      addNewTranslation (language) {
        this.$set(this.template.translation, this.template.translation.length, { language, subject: '', content: '', template_id: this.template.template_id })
        this.currentLanguage = this.template.translation.length - 1
      }
    },

    watch: {
      'template.settings.tournament_finished': function (val) {
        if (!val) {
          delete this.template.settings.tournament_id
          delete this.template.settings.place
        }
      },
      'template.settings.tournament_started': function (val) {
        if (!val) {
          delete this.template.settings.tournament_id
        }
      },
      'template.entity_id': {
        handler () {
          this.loadTournaments()
          this.loadBonusBenefits()
        },
      },
      'template.settings.bonus_notification_type': {
        handler () {
          this.loadBonusBenefits()
        },
      },
    },

    computed: {
      editorText: {
        get () {
          if (!this.isLoadingEditor) {
            return this.template.translation[this.currentLanguage].content
          }
        },
        set (content) {
          this.template.translation[this.currentLanguage].content = content
        }
      },
      languageList () {
        return this.template.translation.map(({ language }) => language)
      },
      newLanguageList () {
        return this.$store.state.auth.languages.filter(newLang => !this.template.translation.find(({ language }) => newLang === language))
      },
      bcc: {
        get () {
          if (!this.template.settings.bcc) {
            this.$set(this.template.settings, 'bcc', [])
          }
          return this.template.settings.bcc
        },
        set (value) {
          this.template.settings.bcc = value
          if (this.template.settings.bcc.length > 6) {
            this.template.settings.bcc.pop()
          }
        }
      },
      notification_id: {
        get () {
          if (!this.template.settings.notification_id) {
            this.$set(this.template.settings, 'notification_id', null)
          }
          return this.template.settings.notification_id
        },
        set (value) {
          this.template.settings.notification_id = value
        }
      },
      mode: {
        get() {
          if (!('mode' in this.template.settings)) {
            this.$set(this.template.settings, 'mode', MODE_ALL)
          }

          return this.template.settings.mode
        },

        set(value) {
          this.template.settings.mode = value
        },
      },
    },

  }
</script>
